export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200 pt-14 md:pt-20 pb-8">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <span className="text-xl font-heading font-bold text-background-50 mb-4 block">911爆料网</span>
            <p className="text-sm text-background-400 leading-relaxed">
              专注吃瓜内容聚合，汇集911吃瓜最新热点、八卦事件与吃瓜素材。一站式浏览各类911爆料吃瓜合集，做你最信赖的吃瓜第一站。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {[
                { label: '吃瓜热度榜', href: '#ranking' },
                { label: '吃瓜专题合集', href: '#index' },
                { label: '最新快讯', href: '#updates' },
                { label: '热点事件', href: '#cards' },
              ].map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系与投稿</h4>
            <ul className="space-y-2">
              {[
                { label: '爆料投稿', href: '#contact' },
                { label: '关于我们', href: '#about' },
                { label: '平台优势', href: '#features' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">合作伙伴信息即将上线，敬请期待。</p>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 911爆料网. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">免责声明</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">内容规范</span>
          </div>
        </div>
      </div>
    </footer>
  );
}